import React from 'react'
import { Box, Typography } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import constants from 'constants/index'

const InternationalTransfer = ({ dataProcess, isLoading = false }) => {
  const { TYPE_INTERNATIONAL_TRANSFER } = constants.legalFrameworks

  const legalFrameworks = dataProcess?.legalFrameworks?.filter(
    (framework) => framework?.dataType === TYPE_INTERNATIONAL_TRANSFER,
  )

  return (
    <Box pb={4}>
      <Typography variant="h5" gutterBottom>
        Transferência Internacional
      </Typography>
      <Table
        noWrap
        emptyMessage="Nenhum enquadramento legal de transferência internacional encontrada!"
        isLoading={isLoading}
      >
        <TableHead>
          <TableRow>
            <TableCell width="40%">Enquadramento Legal</TableCell>
            <TableCell width="60%">Base Legal</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {legalFrameworks?.map((legalFramework) => (
            <TableRow key={legalFramework?.id}>
              <TableCell>{legalFramework?.name}</TableCell>
              <TableCell>{legalFramework?.legalTemplate}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export default InternationalTransfer
